module.exports = __webpack_public_path__ + "media/src/application/media/estimate-78aef0e732df98629f5d4cffa30c32e4.png";